import { toast } from "react-toastify";
import axios from "axios";

export default async function updateItem<T>(url: string, data: T): Promise<T> {
  try {
    const response = await axios.put(url, data);

    toast("Item was successfully updated", {
      type: "success",
    });

    return response.data;
  } catch (error: any) {
    toast("Error while updating item", {
      type: "error",
    });
    return data;
  }
}
